import { render } from "./FormContainer.vue?vue&type=template&id=1d8a8966&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=1d8a8966&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1d8a8966"

export default script